// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"2b10df93","977":"c6a4c35d"}[chunkId] + ".chunk.js";
};